"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.WorkspaceForm = exports.WorkspaceFormInner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var trello_1 = require("@powerupsclub/trello");
var react_1 = require("react");
var spinner_1 = __importDefault(require("@atlaskit/spinner"));
var stripe_js_1 = require("@stripe/stripe-js");
var button_1 = __importStar(require("@atlaskit/button"));
var react_stripe_js_1 = require("@stripe/react-stripe-js");
var form_1 = __importStar(require("@atlaskit/form"));
var textfield_1 = __importDefault(require("@atlaskit/textfield"));
var contexts_1 = require("../contexts");
var styled_components_1 = __importDefault(require("styled-components"));
var Currency = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 14px;\n"], ["\n  font-size: 14px;\n"])));
var CenteredDiv = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n"], ["\n  display: flex;\n  justify-content: center;\n"])));
var PaymentError = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  & > div {\n    color: #ff4b4b;\n  }\n"], ["\n  & > div {\n    color: #ff4b4b;\n  }\n"])));
var CardElementWrapper = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 8px;\n  padding: 8px 6px;\n  background-color: #fafbfc;\n  border-color: #dfe1e6;\n  border-radius: 3px;\n  border-width: 2px;\n  border-style: solid;\n  box-sizing: border-box;\n\n  ", "\n"], ["\n  margin-top: 8px;\n  padding: 8px 6px;\n  background-color: #fafbfc;\n  border-color: #dfe1e6;\n  border-radius: 3px;\n  border-width: 2px;\n  border-style: solid;\n  box-sizing: border-box;\n\n  ", "\n"])), function (props) {
    return props.focused ? 'background-color: #ffffff; border-color: #4c9aff;' : '';
});
var PriceH1 = styled_components_1["default"].h1(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: center;\n  font-size: 24px;\n  line-height: 24px;\n  margin: 8px 0;\n"], ["\n  text-align: center;\n  font-size: 24px;\n  line-height: 24px;\n  margin: 8px 0;\n"])));
var PriceSubHeading = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var stripePromise = (0, stripe_js_1.loadStripe)(process.env.REACT_APP_STRIPE_KEY ||
    'pk_test_51IzTPSE4AkBCYcbadpOO6rS1LdyYfD0oGq4NboxTExCqO4KwS3Sg24lT2FU7uqP8NAATNRffWxcHozWwukJH19wd00elcjQbhl');
var getWorkspaceMembers = function (idOrg, appKey, token) { return __awaiter(void 0, void 0, void 0, function () {
    var response, workspace;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("https://api.trello.com/1/organizations/".concat(idOrg, "/members?key=").concat(appKey, "&token=").concat(token))];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error('failed to get workspace members');
                }
                return [4 /*yield*/, response.json()];
            case 2:
                workspace = _a.sent();
                return [2 /*return*/, workspace];
        }
    });
}); };
var WorkspaceFormInner = function (_a) {
    var onComplete = _a.onComplete, onDismiss = _a.onDismiss, setLicenseType = _a.setLicenseType;
    var _b = (0, react_1.useContext)(trello_1.TrelloPowerUpContext), org = _b.org, token = _b.token, appKey = _b.appKey, me = _b.me, trelloIsLoading = _b.isLoading, trelloIframe = _b.trelloIframe, appName = _b.appName;
    var stripe = (0, react_stripe_js_1.useStripe)();
    var elements = (0, react_stripe_js_1.useElements)();
    var _c = (0, react_1.useContext)(contexts_1.PaymentsContext), subscription = _c.subscription, paymentsIsLoading = _c.isLoading, refetchSubscription = _c.refetchSubscription, trialEndDate = _c.trialEndDate, dismissPaymentModal = _c.dismissPaymentModal, createWorkspaceSubscription = _c.createWorkspaceSubscription;
    var _d = (0, react_1.useState)([]), workspaceMembers = _d[0], setWorkspaceMembers = _d[1];
    var trialEnded = trialEndDate ? new Date() > trialEndDate : false;
    var loading = trelloIsLoading || paymentsIsLoading;
    var _e = (0, react_1.useState)(false), focused = _e[0], setFocused = _e[1];
    var _f = (0, react_1.useState)(false), paymentComplete = _f[0], setPaymentComplete = _f[1];
    var _g = (0, react_1.useState)(false), isPaying = _g[0], setIsPaying = _g[1];
    var _h = (0, react_1.useState)(false), isReloading = _h[0], setIsReloading = _h[1];
    var _j = (0, react_1.useState)(null), paymentError = _j[0], setPaymentError = _j[1];
    var handleSubmit = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var cardElement, _a, error, paymentMethod, newSub, result;
        var _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setPaymentError(null);
                    cardElement = elements.getElement(react_stripe_js_1.CardElement);
                    if (!cardElement) {
                        throw new Error('could not find card element');
                    }
                    setIsPaying(true);
                    return [4 /*yield*/, stripe.createPaymentMethod({
                            type: 'card',
                            card: cardElement
                        })];
                case 1:
                    _a = _d.sent(), error = _a.error, paymentMethod = _a.paymentMethod;
                    if (error) {
                        setPaymentError(error);
                        setIsPaying(false);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createWorkspaceSubscription(org.id, paymentMethod.id, workspaceMembers.length)];
                case 2:
                    newSub = _d.sent();
                    if (!((newSub === null || newSub === void 0 ? void 0 : newSub.status) === 'incomplete' &&
                        ((_c = (_b = newSub === null || newSub === void 0 ? void 0 : newSub.latest_invoice) === null || _b === void 0 ? void 0 : _b.payment_intent) === null || _c === void 0 ? void 0 : _c.status) === 'requires_action')) return [3 /*break*/, 4];
                    return [4 /*yield*/, stripe.confirmCardPayment(newSub.latest_invoice.payment_intent.client_secret, {
                            payment_method: paymentMethod.id
                        })];
                case 3:
                    result = _d.sent();
                    if (result.error) {
                        setPaymentError(result.error);
                        setIsPaying(false);
                        return [2 /*return*/];
                    }
                    if (result.paymentIntent.status === 'succeeded') {
                        newSub = {
                            status: 'active'
                        };
                    }
                    _d.label = 4;
                case 4:
                    if (!((newSub === null || newSub === void 0 ? void 0 : newSub.status) === 'active')) return [3 /*break*/, 7];
                    // re-renders board buttons
                    return [4 /*yield*/, trelloIframe.set('board', 'private', 'rerender', new Date().toISOString())];
                case 5:
                    // re-renders board buttons
                    _d.sent();
                    return [4 /*yield*/, trelloIframe.set('board', 'private', 'rerender:subscription', new Date().toISOString())];
                case 6:
                    _d.sent();
                    setPaymentComplete(true);
                    _d.label = 7;
                case 7:
                    setIsPaying(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var loadOrgDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
            var members, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(org && token)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, getWorkspaceMembers(org.id, appKey, token)];
                    case 2:
                        members = _a.sent();
                        if ((members === null || members === void 0 ? void 0 : members.length) > 0) {
                            setWorkspaceMembers(members);
                        }
                        else {
                            setLicenseType('individual');
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        setLicenseType('individual');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadOrgDetails();
    }, [org, token]);
    if (!stripe || !elements || !subscription || loading || !me) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "loadingSpinnerContainer" }, { children: (0, jsx_runtime_1.jsx)(spinner_1["default"], { size: "large" }, void 0) }), void 0));
    }
    if (paymentComplete) {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: trelloIframe.localizeKey('welcome-to-the-tiny-power-ups-club') }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('your-reciept-and-invoice-will-be-emailed-to-you-shortly') }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('you-and-everyone-in-your-workspace-now-has-unlimited-access-to-all-of-our-power-ups') }, void 0), (0, jsx_runtime_1.jsx)("p", { children: trelloIframe.localizeKey('if-you-ever-have-any-questions') }, void 0), (0, jsx_runtime_1.jsx)(button_1.LoadingButton, __assign({ isLoading: isReloading, appearance: "primary", shouldFitContainer: true, onClick: function (e) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            setIsReloading(true);
                            refetchSubscription({
                                waitForStatus: 'active'
                            });
                            setIsReloading(false);
                            trelloIframe.confetti(e);
                            if (onComplete) {
                                onComplete();
                            }
                            return [2 /*return*/];
                        });
                    }); } }, { children: trelloIframe.localizeKey('back-to-power-up', {
                        powerUpName: appName
                    }) }), void 0)] }, void 0));
    }
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { paddingTop: '8px' } }, { children: [(0, jsx_runtime_1.jsx)(PriceSubHeading, { children: trelloIframe.localizeKey('total-for-n-members', {
                    workspaceMembersCount: workspaceMembers.length
                }) }, void 0), (0, jsx_runtime_1.jsxs)(PriceH1, { children: [trelloIframe.localizeKey('$n-per-month', {
                        workspaceMembersCount: workspaceMembers.length
                    }), ' ', (0, jsx_runtime_1.jsx)(Currency, { children: "(usd)" }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(PriceSubHeading, { children: trelloIframe.localizeKey('priced-at-$1-per-user-per-month') }, void 0), (0, jsx_runtime_1.jsx)(form_1["default"], __assign({ onSubmit: handleSubmit }, { children: function (_a) {
                    var formProps = _a.formProps;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({}, formProps, { children: [(0, jsx_runtime_1.jsx)(form_1.Field, __assign({ name: "name", isRequired: true }, { children: function (_a) {
                                    var fieldProps = _a.fieldProps;
                                    return ((0, jsx_runtime_1.jsx)(textfield_1["default"], __assign({}, fieldProps, { placeholder: "Full name" }), void 0));
                                } }), void 0), (0, jsx_runtime_1.jsx)(CardElementWrapper, __assign({ focused: focused }, { children: (0, jsx_runtime_1.jsx)(react_stripe_js_1.CardElement, { onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); }, options: {
                                        style: {
                                            base: {}
                                        }
                                    } }, void 0) }), void 0), paymentError && ((0, jsx_runtime_1.jsx)(PaymentError, { children: (0, jsx_runtime_1.jsx)(form_1.HelperMessage, { children: paymentError.message }, void 0) }, void 0)), (0, jsx_runtime_1.jsx)(form_1.FormFooter, { children: (0, jsx_runtime_1.jsx)(button_1.LoadingButton, __assign({ shouldFitContainer: true, appearance: "primary", type: "submit", isLoading: isPaying }, { children: trelloIframe.localizeKey('purchase-workspace-license') }), void 0) }, void 0), !trialEnded && ((0, jsx_runtime_1.jsx)(button_1["default"], __assign({ shouldFitContainer: true, appearance: "subtle-link", onClick: function () {
                                    dismissPaymentModal();
                                    if (onDismiss) {
                                        onDismiss();
                                    }
                                } }, { children: trelloIframe.localizeKey('continue-with-free-trial') }), void 0)), (0, jsx_runtime_1.jsx)(CenteredDiv, { children: (0, jsx_runtime_1.jsx)(form_1.HelperMessage, { children: trelloIframe.localizeKey('cancel-anytime-no-pressure') }, void 0) }, void 0)] }), void 0));
                } }), void 0)] }), void 0));
};
exports.WorkspaceFormInner = WorkspaceFormInner;
var WorkspaceForm = function (props) {
    return ((0, jsx_runtime_1.jsx)(react_stripe_js_1.Elements, __assign({ stripe: stripePromise }, { children: (0, jsx_runtime_1.jsx)(exports.WorkspaceFormInner, __assign({}, props), void 0) }), void 0));
};
exports.WorkspaceForm = WorkspaceForm;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=WorkspaceForm.js.map